/**
 * Re-projects a stale tax summary when the cart subtotal has drifted
 * (e.g. after a discount is applied/removed post-tax-calculation).
 */

import type { NormalizedTaxResult } from '../types/tax.types';

/**
 * Get tax summary for display; re-project if subtotal has changed (stale tax).
 * @param taxSummary - Current tax summary from address save
 * @param subtotal - Current net subtotal in currency units
 * @returns Tax summary object for OrderSummary, or null
 */
export function getTaxForSummary(
  taxSummary: NormalizedTaxResult | null,
  subtotal: number
): NormalizedTaxResult | null {
  if (!taxSummary) return null;
  if (Math.abs(taxSummary.subtotal - subtotal) > 0.01) {
    const projectedTax = subtotal * (taxSummary.taxRate || 0);
    const projectedGrandTotal = subtotal + projectedTax;
    return {
      ...taxSummary,
      subtotal,
      taxAmount: projectedTax,
      grandTotal: projectedGrandTotal,
    };
  }
  return taxSummary;
}
